import { EndMeet } from '../components/end-meet';

export const EndMeetPage = () => {
  return <EndMeet />;
};
